import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finalidades-de-uso',
  templateUrl: './finalidades-de-uso.component.html',
  styleUrls: ['./finalidades-de-uso.component.scss'],
})
export class FinalidadesDeUsoComponent implements OnInit {
  firstCardList: Array<object>;
  secondCardList: Array<object>;

  constructor() {
    this.firstCardList = [
      {
        cardIconUrl: 'assets/icon-authenticate.svg',
        cardTitle: 'Para a proteção do crédito',
        cardDescription:
          'Nós ajudamos nossos clientes a ter os dados necessários para fazer uma análise de crédito mais assertiva. O Score de Crédito é uma das principais soluções que oferecemos, sendo composto por dados cadastrais, informações negativas e positivas e consultas realizadas pelos clientes da Serasa ao seu CPF.',
        cardDescriptionFull:
          '<strong>Análise e concessão de crédito e gerenciamento de carteira de clientes:</strong> Quanto melhor os credores conhecerem o seu perfil de crédito, mais adequadas serão as condições de concessão de crédito e realização de negócios com você.<br /><br /><strong>Negativação e cobrança:</strong> Compartilhamos dados de dívidas para possibilitar a prevenção ao superendividamento, a definição de condições mais adequadas para o ciclo de crédito e a saúde da economia do país.<br /><br /><strong>Precificação:</strong> Conhecer o perfil de risco de cada cliente ajuda a definir os preços mais adequados para serviços que possibilitam essa adequação, como seguros.<br /><br /><strong>Ofertas direcionadas de crédito:</strong> Conhecer o perfil de crédito permite avaliar adequadamente o risco financeiro para o adequado direcionamento de ofertas de crédito, como, por exemplo, de cartão de crédito.',
      },
      {
        cardIconUrl: 'assets/icon-fraud-1.svg',
        cardTitle:
          'Para identificação e autenticação de indivíduos e prevenção a fraudes',
        cardDescription:
          'Nós ajudamos indivíduos e empresas a evitar fraudes e confirmar e proteger a sua identidade.',
        cardDescriptionFull:
          '<strong>Trabalhamos muito para ajudar a protegê-lo contra fraudes:</strong> ajudamos nossos clientes a prevenirem-se contra fraudadores que desejam contratar se passando por outras pessoas. Isso também ajuda você a se proteger desses fraudadores quando você faz cadastros em sites, abre contas e acessa serviços on-line.<br><br>Também oferecemos soluções diretamente para você, como o monitoramento de seus dados na Serasa Experian ou mesmo na DarkWeb, para ser informado e tomar providências rapidamente caso alguém tente usar seu CPF ou outros documentos. Temos, ainda, soluções para você se autenticar de forma rápida e segura em ambiente eletrônico.',
      },
      {
        cardIconUrl: 'assets/icon-invalid-name.svg',
        cardTitle: 'Para aprimoramento da qualidade de dados',
        cardDescription:
          'Nossas soluções ajudam nossos clientes a cuidar da qualidade dos seus dados pessoais, garantindo assim o cumprimento deste seu direito protegido pela LGPD.',
        cardDescriptionFull:
          'Nossas soluções ajudam nossos clientes a cuidar da qualidade dos seus dados pessoais, garantindo assim o cumprimento deste seu direito protegido pela LGPD.',
      },
      {
        cardIconUrl: 'assets/icon-big-data.svg',
        cardTitle: 'Para direcionamento de ofertas',
        cardDescription:
          'A partir da segmentação de perfis, você pode ter acesso a produtos e serviços com mais probabilidade de afinidade com você.',
        cardDescriptionFull:
          'Acreditamos que as soluções de segmentação de perfis podem trazem benefícios significativos para você, empresas e a sociedade. Nós tratamos dados e informações para ajudar a unir empresas e consumidores e, ainda, para que as ofertas de produtos e serviços que você receba sejam realmente relevantes para você.',
        cardLink: '/direcionamento-de-ofertas',
      },
    ];

    this.secondCardList = [
      {
        cardIconUrl: 'assets/icon-telecommunications.svg',
        cardTitle: 'Telecomunicações',
      },
      {
        cardIconUrl: 'assets/icon-money.svg',
        cardTitle: 'Bancos e Instituições Financeiras',
      },
      {
        cardIconUrl: 'assets/icon-fraud-2.svg',
        cardTitle: 'Seguradoras',
      },
      {
        cardIconUrl: 'assets/icon-money-card.svg',
        cardTitle: 'Varejo',
      },
      {
        cardIconUrl: 'assets/icon-gear.svg',
        cardTitle: 'Indústrias',
      },
      {
        cardIconUrl: 'assets/icon-house-money.svg',
        cardTitle: 'Pequenas e médias empresas',
      },
    ];
  }

  ngOnInit(): void {}
}
